<template>
  <button class="px-2 mx-0.5 hover:outline outline-1 outline-brand rounded-full"><slot /></button>
</template>